module.exports = __webpack_public_path__ + "static/Oswald-Regular-d55ae3c53ae77ec203324a3fb090bfe7.woff";